import AlEmailTemplateEditorPreviewModalController from '../controllers/modals/preview-modal-controller';
import previewModalTemplate from '../views/modals/preview-modal.tpl.html';

export default function templatePreviewStarter($injector, template, guestlistId) {
    return $injector.get('$uibModal')
        .open({
            controller: AlEmailTemplateEditorPreviewModalController,
            controllerAs: 'vm',
            templateUrl: previewModalTemplate,
            size: 'xlg',
            windowClass: 'modal-fixed',
            keyboard: false,
            backdrop: 'static',
            resolve: {
                guestlistId: () => guestlistId,
                template: () => template
            }
        })
        .result;
}



// WEBPACK FOOTER //
// ./src/app/modules/templates/helpers/template-preview-starter.js